<div id="agb-form-spec" class="position-relative dialog-popup" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type" >
  <a class="text-gray position-absolute" style="right:0" [mat-dialog-close]="true"><span
  class="material-symbols-outlined">close</span>
</a>
<h1 class="pb-0 agb-popup-title" [innerHTML]="data.title"></h1>
<h2 class="my-m">Bitte beachten Sie:</h2>
@for (part of parsedBody; track part) {
  <div>
    @if (part.type == 'string') {
      <div [innerHTML]="part.data" class="mb-m"></div>
    }
    @if (part.type=='form') {
      <app-forms [form]="part.data" (success)="onSuccess($event)"></app-forms>
    }
  </div>
}
</div>
